export default __webpack_public_path__ + "assets/images/nft-image.jpeg";